import { Subscription } from '../../../../../types/subscription';
import { useState } from 'react';
import { colors } from '../../../../../colors';
import {
  useStartComplexParamsCalculationMutation,
  useUpdateFeatureFlagMutation,
} from '../../../../../store/services/api';
import Checkbox from '../../../../../components/Checkbox';
import { Bot } from 'grts-utils/types/Bot';

interface Props {
  bot: Bot | undefined;
}

const ComplexParamsCaluclation = ({ bot }: Props) => {
  const [startComplexParamsCalculation] =
    useStartComplexParamsCalculationMutation();

  const [didError, setIsError] = useState(false);
  const [didStart, setDidStart] = useState<boolean | undefined>();

  const handleSubmit = async () => {
    if (!bot) {
      return;
    }

    try {
      const result = await startComplexParamsCalculation({
        botFriendlyName: bot.botId,
        skipQueue: true,
      });

      if (result.error) {
        setIsError(true);
      }

      if (result.data?.didStart !== undefined) {
        setDidStart(result.data?.didStart);
        setIsError(false);
      }
    } catch (error) {
      setIsError(true);
    }
  };

  return (
    <div
      style={{
        flex: 1,
        marginLeft: 16,
        borderBottom: '0.5px solid rgba(80, 80, 80, 0.5)',
        paddingBottom: 32,
      }}
    >
      <p
        style={{
          color: 'white',
          fontWeight: 'bold',
          fontSize: 20,
          marginBottom: 5,
        }}
      >
        Complex Params Calulcations
      </p>
      <button
        style={{
          backgroundColor: colors.green,
          paddingLeft: 16,
          paddingRight: 16,
          paddingTop: 8,
          paddingBottom: 8,
          color: colors.white,
          borderRadius: 4,
          fontWeight: 800,
          border: 0,
          cursor: 'pointer',
        }}
        onClick={handleSubmit}
      >
        Start
      </button>
      {didStart !== undefined && (
        <p
          style={{ color: colors.green, fontSize: 14, margin: 0, marginTop: 6 }}
        >
          {didStart
            ? 'Complex Params Calculations has begun. This will take a while.'
            : 'Request has been added to the queue.'}
        </p>
      )}
      {didError && (
        <p style={{ color: colors.red, fontSize: 14, margin: 0, marginTop: 6 }}>
          Something went wrong.
        </p>
      )}
    </div>
  );
};

const FeatureFlag = ({ bot }: Props) => {
  const [updateFeatureFlag] = useUpdateFeatureFlagMutation();

  const [isFeatureFlagEnabled, setIsFeatureFlagEnabled] = useState(
    bot?.featureFlag ?? false,
  );

  const handleFeatureFlagToggle = async () => {
    if (!bot) {
      return;
    }

    const updatedValue = !isFeatureFlagEnabled;

    setIsFeatureFlagEnabled(updatedValue);
    await updateFeatureFlag({ botId: bot.id, featureFlag: updatedValue });
  };

  return (
    <div
      style={{
        flex: 1,
        marginLeft: 16,
        borderBottom: '0.5px solid rgba(80, 80, 80, 0.5)',
        paddingBottom: 32,
      }}
    >
      <p
        style={{
          color: 'white',
          fontWeight: 'bold',
          fontSize: 20,
          marginBottom: 5,
        }}
      >
        Feature Flag
      </p>
      <Checkbox
        label={'Take Profit Transaction Feature Flag'}
        value={isFeatureFlagEnabled}
        handleValueChange={handleFeatureFlagToggle}
        color={colors.orange}
      />
    </div>
  );
};

const ManageCalculations = ({ bot }: Props) => {
  return (
    <>
      <ComplexParamsCaluclation bot={bot} />
      <FeatureFlag bot={bot} />
    </>
  );
};

export default ManageCalculations;
